export class SearchCondition {
  room_code: string = ""
  name: string = ""
}

export class Room {
  id: number
  room_code: number
  name: string

  constructor(room: any){
    this.id = room.id;
    this.room_code = room.room_code;
    this.name = room.name;
  }
}